




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import Nullable from '@/types/nullable';

@Component({})
export default class JobLocation extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;

  get viewLocationHref(){
    let locationParts = [
      this.job.client.location.address.street,
      this.job.client.location.address.suburb,
      this.job.client.location.address.postCode,
      this.job.client.location.address.state
    ].filter(x => x && x.length > 0);

    if(locationParts.length == 0){
      return null;
    }
  
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationParts.join(" "))}`;
  }

  viewSafetyDocumention(){
    this.$router.push({ name: 'viewjobsafetydocs', params: { jobID: this.job.id } });
  }
  viewTake5(){
    this.$router.push({name: 'viewjobtake5', params: { jobID: this.job.id } })
  }
}

